import { render, staticRenderFns } from "./Professor-disciplina-novo.vue?vue&type=template&id=9694aa78&"
import script from "./Professor-disciplina-novo.vue?vue&type=script&lang=js&"
export * from "./Professor-disciplina-novo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports